module.exports = __webpack_public_path__ + "img/bg-drawer.7ba9e123.jpg";